import Vue from 'vue';
import prettyBytes from 'pretty-bytes';

export { prettyBytes };
Vue.filter('prettyBytes', prettyBytes);
